import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyB1cvAnEy-mU7rZJualz_dbGu1i6lYNph4",
  authDomain: "webteam11-b54d0.firebaseapp.com",
  projectId: "webteam11-b54d0",
  storageBucket: "webteam11-b54d0.firebasestorage.app",
  messagingSenderId: "311875938358",
  appId: "1:311875938358:web:fd406ed711257d3825d097",
  measurementId: "G-D712LQR0NC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Cloud Messaging(FCM)
const messaging = getMessaging(app);

export {messaging, getToken, onMessage };